export default __webpack_public_path__ + "static/media/ctc.a32d90e5.png";